module.exports = __webpack_public_path__ + "static/don49-97db40d924ca0d44de1c73cd4cf13fb7.jpg";